import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { createMatchSelector } from 'connected-react-router';
import { compose, path, pipe, applySpec } from 'ramda';
import { withTranslation } from 'react-i18next';
import { getPatientShouldShowLoading } from 'store/selectors/patientsData';
import withPageLoader from 'components/withPageLoader';
import { FORM_NAMES } from 'constants/forms';
import { requestPatientsData } from 'store/actionCreators/patientsData';
import { parsePdf, uploadCardioVascularReport } from 'store/actionCreators/newCardioReport';
import UploadCardioReport from 'components/UploadCardioReport';
import validate from './validate';

export default compose(
  withTranslation(),
  connect(
    null,
    { parsePdf, onSubmit: uploadCardioVascularReport },
  ),
  withPageLoader({
    loadingSelector: (
      state,
      {
        match: {
          params: { id },
        },
      },
    ) => getPatientShouldShowLoading(id)(state),
    initialActionArgsSelector: applySpec({
      id: pipe(
        createMatchSelector('/patient/:id'),
        path(['params', 'id']),
      ),
    }),
    initialAction: requestPatientsData,
  }),
  reduxForm({
    form: FORM_NAMES.uploadCardioReport,
    validate,
  }),
)(UploadCardioReport);
